// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__Deovq","title":"style_title__sTf4_","body":"style_body__DIV1z"};